import * as Yup from 'yup'
import { phoneRegExp } from '../../helpers'

export const delegateValidationSchema = Yup.object().shape({
  firstName: Yup.string().required('First name is required'),
  lastName: Yup.string().required('Last name is required'),
  email: Yup.string().email('Invalid email format').required('Email is required'),
  phone: Yup.string().matches(phoneRegExp, 'Phone number is invalid').required('Phone is required')
})

export const delegateFromListValidationSchema = Yup.object().shape({
  id: Yup.number().required('You must select a delegate')
})
